import type { ReasonCategory } from '@/shared/utils/format-status.js';

export type ReasonResponse = {
    id: string;
    label: string;
    category: ReasonCategory;
    isActive: boolean;
    sortOrder: number;
};

export type ReasonProps = {
    id: string;
    label: string;
    category: ReasonCategory;
    isActive: boolean;
    sortOrder: number;
};

export class ReasonModel {
    private constructor(private readonly props: ReasonProps) {}

    public static with(props: ReasonProps): ReasonModel {
        return new ReasonModel(props);
    }

    public static withFromResponse(response: ReasonResponse): ReasonModel {
        return ReasonModel.with({ ...response });
    }

    public static withFromResponseList(list: ReasonResponse[]): ReasonModel[] {
        return list.map(ReasonModel.withFromResponse);
    }

    public get id(): string {
        return this.props.id;
    }

    public get label(): string {
        return this.props.label;
    }

    public get category(): ReasonCategory {
        return this.props.category;
    }

    public get isActive(): boolean {
        return this.props.isActive;
    }

    public get sortOrder(): number {
        return this.props.sortOrder;
    }

    public toObject(): ReasonProps {
        return { ...this.props };
    }
}

export type CreateReasonParams = {
    label: string;
    category: ReasonCategory;
    sortOrder?: number;
};

export type UpdateReasonParams = {
    label: string;
    category: ReasonCategory;
    sortOrder?: number;
};
